import type { TicketStatus } from '../types';

/** Every status except the done ones (completed / closed), i.e. work that is still open (Q-026b, D-146). */
export const OPEN_TICKET_STATUSES: readonly TicketStatus[] = ['planning', 'in_progress', 'in_review', 'testing', 'new', 'waiting_customer'];

/** `status` query value for GET /api/tickets that selects open work. */
export const OPEN_TICKET_STATUS_PARAM = OPEN_TICKET_STATUSES.join(',');
